import { useEffect } from 'react';

export const useScrollToBottom = (ref, data) => {
  useEffect(() => {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: "smooth" })
    }
  }, [data, ref]);
};
